import React from 'react'
import PropTypes from 'prop-types'

import { Table, Button, Icon } from 'shpmtcd'
import * as GA from '../../Analytics/googleAnalytics'

const calcDiscount = ({ display_price, display_list_price }) => {
  const nDisPrice = display_price && parseInt(display_price, 10);
  const nDisListPrice = display_list_price && parseInt(display_list_price, 10);
  if (nDisListPrice) {
    const disPercentage = ((nDisListPrice - nDisPrice)/nDisListPrice) * 100
    return disPercentage ? `${parseInt(disPercentage)}% off` : false
  }
  return false;
}

const generateColumnData = (removeWishlistedProduct) => {
  const columns = [
    {
      key: 'date',
      width: '120px',
      render: data => (
        <a href={`/products/${data.slug}`} >
          <img
            src={data.image_url || '/missing.jpg'}
            alt={data.name}
            className='wproduct__img'
          />
        </a>
      ),
    },
    {
      key: 'status',
      width: '300px',
      render: data => (
        <div>          
          <h3 className='wproduct__hdr'>
            <a href={`/products/${data.slug}`} className='wproduct__hdr--link'>{data.name}</a>
          </h3>
          <p className='wproduct__details'>
            <span className='wproduct__price'>{data.currency} {parseInt(data.display_price).toFixed(2)}</span>
            { data.display_list_price && <span className='wproduct__price--original'>{data.currency} {parseInt(data.display_list_price).toFixed(2)}</span> }
          </p>
          { calcDiscount(data) && <span className='wproduct__discount'>{ calcDiscount(data) }</span> }
        </div>
      ),
    },
    {
      key: 'description',
      render: data => (
        <span className='wproduct__bookmarkBtn'>
          <Button
            type='link'
            onClick={() => {
              if (navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({
                  TYPE: 'REMOVE_FROM_BUYER_WISHLIST',
                  payload: [{ ...data }],
                })
                removeWishlistedProduct([{ ...data}])

                GA.fireEvent({
                  event:'WishlistIconClicked',
                  category: 'Wishlist',
                  action: 'Wishlist_Icon_Clicked',
                  label: `Remove_${data.name}_${data.variant_id}`,
                })
              }
              return false
            }}
            style={{
              'background': 'none',
              'border-radius': 0,
              'padding': 0,
              'font-size': '1.75rem',
              'line-height': 1,
              'min-width': 'auto',
              'border': 'none',
              'color': '#FF1755'
            }}
          >
            <Icon type='shpmtcdicon-zen-wishlist-checked' />
          </Button>
        </span>
      ),
    },
  ]

  return columns
}

const emptyContent = (
  <div className='wproduct__norecord'>
    <h3>Wishlist is empty. Start adding products to the wishlist now.</h3>
    <Button
      type='Ghost'
    >
      <a href={window.location.origin} className='go-to-shop-link'>Go to shop</a>
    </Button>
  </div>
)
const empty = {
  emptyText: emptyContent,
}

const WishlistTable = ({
  products,
  loading,
  pagination,
  onChangePag,
  removeWishlistedProduct
}) => {
  debugger
  return (
  <Table
    showHeader={false}
    className='wproduct__table'
    columns={generateColumnData(removeWishlistedProduct)}
    dataSource={products}
    scroll={{ x: 500 }}
    loading={loading.loading}
    pagination={{ ...pagination, onChange: onChangePag }}
    locale={empty}
  />
)
  }
WishlistTable.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
  })),
  loading: PropTypes.bool,
  pagination: PropTypes.shape({
    current: PropTypes.number.isRequired,
    defaultPageSize: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  onChangePag: PropTypes.func.isRequired,
}

WishlistTable.defaultProps = {
  products: [],
  loading: {
    loading: false,
  },
  onChangePag: () => {},
  pagination: {},
}

export default WishlistTable